import { render, staticRenderFns } from "./ArticleHeader.vue?vue&type=template&id=ee91978c&scoped=true&"
import script from "./ArticleHeader.vue?vue&type=script&lang=js&"
export * from "./ArticleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ArticleHeader.vue?vue&type=style&index=0&id=ee91978c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee91978c",
  null
  
)

export default component.exports